import { isActiveAnalyticsGroup } from '@helpers/cookie';
import { isBooztmobile, isProdEnv } from '@helpers/env';
import { isFeatureActive } from '@helpers/index';
import { isSmallScreen } from '@helpers/responsiveHelper';
import { getVisitorId } from '@helpers/visitor';

let isSnowplowTrackerInitialized = false;

const isShopBooztletTheme = config => config.webshop.id === 'shopbooztlet';

export const getSnowplowTracker = () => window.snowplow_boozt;

const flushBuffer = tracker => () => {
    tracker('flushBuffer');
};

const getSnowplowTrackerAppId = (config) => {
    if (isProdEnv()) {
        if (isShopBooztletTheme(config)) {
            return 'booztlet_web';
        }

        return 'boozt_web';
    }

    if (isShopBooztletTheme(config)) {
        return 'test_booztlet_web';
    }

    return 'test_boozt_web';
};

const enableAnonymousTracking = () => {
    if (!isFeatureActive('PLT-72071_enable_snowplow_anonymous_tracking')) {
        return false;
    }

    try {
        return !isActiveAnalyticsGroup();
    } catch (e) {
        return false;
    }
};

export const handleSnowplowTrackerInitialisation = (config) => {
    const tracker = getSnowplowTracker();

    if (!isSnowplowTrackerInitialized && typeof tracker === 'function') {
        const snowplowConfig = {
            id: 'boozt',
            stateStorageStrategy: 'localStorage',
            platform: isBooztmobile(config) ? 'mob' : 'web',
            customOptions: {}
        };

        if (isShopBooztletTheme(config)) {
            snowplowConfig.id = 'booztlet';
            snowplowConfig.platform = isSmallScreen() ? 'mob' : 'web';
        }

        if (enableAnonymousTracking()) {
            snowplowConfig.customOptions = {
                stateStorageStrategy: 'cookieAndLocalStorage',
                anonymousTracking: true
            };
        }

        tracker('newTracker', snowplowConfig.id, `sp.${snowplowConfig.id}.com`, {
            appId: getSnowplowTrackerAppId(config),
            cookieDomain: `${snowplowConfig.id}.com`,
            bufferSize: 10,
            eventMethod: 'beacon',
            stateStorageStrategy: 'localStorage',
            platform: snowplowConfig.platform,
            ...snowplowConfig.customOptions
        });

        tracker('setUserId', getVisitorId());
        // flush buffer every 5 sec
        setInterval(flushBuffer(tracker), 5000);

        isSnowplowTrackerInitialized = true;
    }
};

export const init = () => {
    const types = ['GTM', 'ContentSquare'];

    types.forEach((type) => {
        let trackerCode = App.Config.gtm;

        if (type === 'ContentSquare') {
            trackerCode = App.Config.contentSquare;
        }

        if (trackerCode !== null) {
            window.addEventListener('load', () => {
                const scr = document.createElement('script');

                scr.type = 'text/javascript';
                scr.async = true;
                scr.innerHTML = trackerCode;

                document.body.appendChild(scr);
            });
        }
    });
};
